import { createSyncObservable } from "@avensia/excite";

const cookiesAcceptedLocalStorageKey = 'accept_cookies';

let initialState = __BROWSER__ ? localStorage.getItem(cookiesAcceptedLocalStorageKey) === '1': false;

export const [acceptedCookies] = createSyncObservable<boolean>(initialState);

if (__BROWSER__){
  acceptedCookies.on(data => {
    localStorage.setItem(cookiesAcceptedLocalStorageKey, data ? '1': '0');
  });
}

